import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ExpenseTable = () => {
  const expenses = [
    { name: "Online Course", date: "14 Jan 2024", method: "Cash", amount: 3000 },
    { name: "Travel", date: "14 Jan 2024", method: "Cheque", amount: 2800 },
    { name: "Offices Supplies", date: "14 Jan 2024", method: "Cash", amount: 3300 },
    { name: "Welcome Kit", date: "14 Jan 2024", method: "Cheque", amount: 3600 },
    { name: "Online Course", date: "14 Jan 2024", method: "Cash", amount: 3000 },
    { name: "Travel", date: "14 Jan 2024", method: "Cheque", amount: 2800 },
  ];

  return (
    <div className="container-fluid py-4 px-0">
      <div className="card shadow-sm border-0 rounded-0">
        <div className="card-body p-0">
          <div className="table-responsive mb-0 ">
            <table className="table mb-0 align-middle table-hover">
              <thead className="table-light">
                <tr>
                  <th className="px-4 py-3">Expense Name</th>
                  <th className="py-3">Date</th>
                  <th className="py-3">Payment Method</th>
                  <th className="text-end px-4 py-3">Amount</th>
                </tr>
              </thead>

              <tbody>
                {expenses.map((item, index) => (
                  <tr key={index} className="border-top">
                    <td className="px-4 py-2 fw-semibold">
                      {item.name}
                    </td>

                    <td className="py-2 text-muted">
                      {item.date}
                    </td>

                    <td className="py-3">
                      <div className="d-flex align-items-center gap-2">
                        <span>{item.method}</span>
                        <img
                          src="https://i.pravatar.cc/30"
                          alt="avatar"
                          className="rounded-circle"
                          width="30"
                          height="30"
                        />
                      </div>
                    </td>

                    <td className="text-end px-4 py-3 fw-semibold">
                      ${item.amount}
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseTable;